import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ProjetcsService } from '../../../projects/projetcs.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';
import { APP_ENV } from 'src/app/shared/conf/app_env';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { PRODUCTIONCOUNTRY } from '../../interfaces/production-country';

@Component({
    selector: 'app-add-scene',
    templateUrl: './add-scene.component.html',
    styleUrls: ['./add-scene.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AddSceneComponent implements OnInit {

	@Input() viewData: any;
	@Input() scene: any;
	@Input() duplicate: boolean;
	@Input() project: any;
	@Input() proyect_type_id: any;
	@Input() scene_id: any;

	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	readonly APP_ENV = APP_ENV;
	readonly environment = environment;
	readonly PRODUCTIONCOUNTRY = PRODUCTIONCOUNTRY;

	loading: boolean = true;
	projectId: string;
	position: string = 'home';
	formData: any = {
		'scene_id': '',
		'scene_type': 1,
		'scene_protection_type_id': '',
		'chapter_id': '',
		'scene_number': '',
		'year': '',
		'day_history': '',
		'page': '',
		'pages': '',
		'projected_minutes': '',
		'location_studio_option_id': '',
		'interior_exterior_option_id': '',
		'day_night_option_id': '',
		'location_id': '',
		'location_name': undefined,
		'location_set_id': '',
		'location_set_name': undefined,
		'added_scene': '',
		'establishing_shoot': '',
		'flashback': '',
		'manually_produced': '',
		'description': '',
		'changes_applied': '',
		'characters': [],
		'elements': [],
		'events': [],
		'comments': []
	}
	filteredCharacters: any = [];
	filteredElements: any = [];
	filteredEvents: any = [];
	selectedSets: any = [];
	responseError: string = '';

	list_chapters: any = [];
	list_scenes: any = [];
	filtered_scenes: any = [];
	copyFormData: any = {
		'chapter_id': '',
		'scene_id': ''
	}
	cont: number = 0;

	changePosition(ev) {
		this.position = ev;
		if (ev == 'copy') {
			this.loading = true;
			this.getScenes()
		}
	}
	getScenes() {
		this._pS.getChaptersScenes(this._gS.projectSelected.id)
			.subscribe(
				data => {
					const rdata: any = data;
					this.list_chapters = rdata.chapters;
					this.list_scenes = rdata.scenes;
					this.loading = false;
				}
			)
	}
	copyData() {
		this.loading = true;
		this._pS.getSceneDetail(this.copyFormData.scene_id)
			.subscribe(
				data => {
					const rdata: any = data;
					const a = this.formData.location_id
					const b = this.formData.location_set_id
					this.copyCharacters(rdata.rol_characters);
					this.copyElements(rdata.category_elements)
					this.formData.location_id = a
					setTimeout(() => {
						this.formData.location_set_id = b
					}, 300);
					this.changePosition('home');
					this.loading = false;
				}
			)
	}
	copyCharacters(ev) {
		for (let sc of ev) {
			for (let ca of sc.characters) {
				const b: any = {
					'character_role_id': ca.character_role_id ? ca.character_role_id : '',
					'character_id': ca.character_id,
					'character_name': '',
					'quantity': ca.quantity,
					'change': ca.change,
				}
				const exist = this.formData.characters.find(element => element.character_id == b.character_id)
				if (!exist) {
					this.formData.characters.push(b)
				}
			}
		}
	}
	copyElements(ev) {
		for (let cat of ev) {
			for (let el of cat.elements) {
				const b: any = {
					'element_id': el.element_id,
					'element_category_id': el.element_category_id,
					'element_name': undefined
				}
				const exist = this.formData.elements.find(element => element.element_id == b.element_id)
				if (!exist) {
					this.formData.elements.push(b)
				}
			}
		}
	}
	selectedChapter() {
		if (this.copyFormData.chapter_id) {
			this.filtered_scenes = this._fS.ElementInList(this.list_scenes, 'chapter_id', this.copyFormData.chapter_id)
		}
	}
	selectedCharacter(pos) {
		if (!this.formData.characters[pos].character_role_id && this.formData.characters[pos].character_id && !this.formData.characters[pos].character_role) {
			const char = this.filteredCharacters[pos].find(element => element.id == this.formData.characters[pos].character_id);
			this.formData.characters[pos].character_role_id = char.character_role_id;
		}
		if (this.scene.characters_list) {
			this.formData.characters[pos].wd_change = '';
			this.formData.characters[pos].wd_comment = '';
			let chFind = this.scene.characters_list.find(cha => cha.character_id == this.formData.characters[pos].character_id);
			this.formData.characters[pos]['wd_change'] = chFind?.wd_change;
			this.formData.characters[pos]['wd_comment'] = chFind?.wd_comment;
		}
	}
	selectedElements(pos) {
		if (!this.formData.elements[pos].element_category_id && this.formData.elements[pos].element_id && !this.formData.elements[pos].element_category) {
			const char = this.filteredElements[pos].find(element => element.id == this.formData.elements[pos].element_id);
			this.formData.elements[pos].element_category_id = char.element_category_id;
		}
	}
	selectedEvents(pos) {
		
		if (!this.formData.events[pos].event_type_id && this.formData.events[pos].event_id && !this.formData.events[pos].event_type_id) {
			const char = this.filteredEvents[pos].find(element => element.id == this.formData.events[pos].event_id);
			this.formData.events[pos].event_type_id = char.event_type_id;
		}
	}
	submitForm() {
    		this.loading = true;
		this.responseError = '';
		this._pS.createScene(this.formData)
			.subscribe(
				data => {
					const rdata: any = data;
					if (rdata.error) {
						this.loading = false
						this.responseError = rdata.error
					} else {
						this.notify.emit()
					}
				}
			)
	}
	restartProtectionType() {
		if (this.formData.scene_type == 1) {
			this.formData.scene_protection_type_id = ''
		}
	}
	filterSets() {
		this.formData.location_set_id = ''
		if (!this.formData.location_name) {
			this.selectedSets = this.viewData?.location_sets 
			this.selectedSets = this._fS.ElementInList(this.viewData?.location_sets, 'location_id', this.formData?.location_id)
		} else {
			this.selectedSets = []
		}
	}

	addCharacter() {
		const a: any = {
			'character_id': '',
			'character_role_id': '',
			'character_name': '',
			'character_role': '',
			'quantity': '',
			'project_id': '',
			'wd_change': '',
			'wd_comment': '',
		}
		this.formData.characters.push(a)
		const b = Object.assign([], this.viewData.characters);
		this.filteredCharacters.push(b)
	}
	deleteCharacter(ev) {
		this.formData.characters.splice(ev, 1);
		this.filteredCharacters.splice(ev, 1);
	}
	roleChange(pos, cast = null) {
		this.filteredCharacters[pos] = this.viewData.characters;
		this.filteredCharacters[pos] = this._fS.ElementInList(this.filteredCharacters[pos], 'character_role_id', this.formData.characters[pos].character_role_id);
		const charSelected = this.viewData.characters.find((cha: any) => cha.id == this.formData.characters[pos].character_id);
		const a = this.formData.characters[pos].character_id;
		const b = this.formData.characters[pos].character_role_id;
		if (this.formData.characters[pos].character_id) {
			const found = this.filteredCharacters[pos].find(function (element) {
				return element.id == a && (!element.character_role_id || element.character_role_id == b)
			});
			if (!found) {
				this.formData.characters[pos].character_id = undefined;
			}
		}
		this.formData.characters[pos].character_role ? this.formData.characters[pos].project_id = this.projectId : this.formData.characters[pos].project_id = undefined;
		if (cast) cast.use_quantity = this.viewData.character_roles.find(c => c.id == cast.character_role_id)?.use_quantity;
		if (!charSelected.character_role_id) {
			this.formData.characters[pos].character_id = charSelected.id;
		}
	}
	elementChange(pos) {
		this.filteredElements[pos] = this.viewData.elements;
		this.filteredElements[pos] = this._fS.ElementInList(this.filteredElements[pos], 'element_category_id', this.formData.elements[pos].element_category_id);
		const a = this.formData.elements[pos].element_id;
		const b = this.formData.elements[pos].element_category_id;

		if (this.formData.elements[pos].element_id) {
			const found = this.filteredElements[pos].find(function (element) {
				return element.id == a && (!element.element_category_id || element.element_category_id == b)
			});
			if (!found) {
				this.formData.elements[pos].element_id = undefined;
			}
		}

		this.formData.elements[pos].element_category ? this.formData.elements[pos].project_id = this.projectId : this.formData.elements[pos].project_id = undefined;
	}
	eventChange(pos) {
		this.filteredEvents[pos] = this.viewData.events;
		this.filteredEvents[pos] = this._fS.ElementInList(this.filteredEvents[pos], 'event_type_id', this.formData.events[pos].event_type_id);
		const a = this.formData.events[pos].event_id;
		const b = this.formData.events[pos].event_type_id;

		if (this.formData.events[pos].event_id) {
			const found = this.filteredEvents[pos].find(function (element) {
				return element.id == a && (!element.event_type_id || element.event_type_id == b)
			});
			if (!found) {
				this.formData.events[pos].event_id = undefined;
			}
		}
	}
	addElement() {
		const a: any = {
			'element_id': '',
			'element_category_id': '',
			'element_name': '',
			'element_category': '',
			'project_id': '',
		}
		this.formData.elements.push(a)
		const b = Object.assign([], this.viewData.elements);
		this.filteredElements.push(b)
	}
	deleteElement(ev) {
		this.formData.elements.splice(ev, 1);
		this.filteredElements.splice(ev, 1);
	}
	
	addEvent() {
		const a: any = {
			'event_id': '',
			'event_name': '',
			'event_type_id': '',
			'quantity': '',
		}
		this.formData.events.push(a)
		const b = Object.assign([], this.viewData.events);
		this.filteredEvents.push(b)
	}

	deleteEvent(ev) {
		this.formData.events.splice(ev, 1);
		this.filteredEvents.splice(ev, 1);

	}
	addComment() {
		const a: any = {
			'comment_id': '',
			'comment': '',
			'user_id': ''
		}
		this.formData.comments.push(a)
	}
	deleteComment(ev) {
		this.formData.comments.splice(ev, 1);
	}
	checkInvalidForm() {
		let r = false
		if((this.formData.scene_type == 1) && (!this.formData.projected_minutes || Number(this.formData.projected_minutes) == 0 )){
			r = true
		}
		for (let item of this.formData.characters) {
			console.log(item);
			if (item.character_id === '' || item.character_role === '' || item.character_role_id === null) {
			  r = true
			}
		}
		for (let item of this.formData.elements) {
			if ((item.element_id === '' || item.element_category_id === '')) {
				r = true
			}
		}
		for (let item of this.formData.events) {
			if ((item.element_id === '' || item.event_type_id === '')) {
				r = true
			}
		}
		return r
	}
	setValues() {
		this.filterSets();
		this.formData = {
			'scene_id': !this.duplicate ? this.scene.id : '',
			'scene_type': this.scene.scene_type_id,
			'scene_protection_type_id': this.scene.scene_protection_type_id,
			'chapter_id': !this.duplicate ? this.scene.chapter_id : '',
			'scene_number': !this.duplicate ? this.scene.scene_number : '',
			'year': this.scene.year ? this.scene.year : '',
			'day_history': this.scene.day_of_history,
			'page': this.scene.page ? this.scene.page : '',
			'pages': this.scene.pages ? this.scene.pages : '',
			'projected_minutes': this.scene.projected_seconds,
			'location_studio_option_id': this.scene.scene_location_studio_option_id,
			'interior_exterior_option_id': this.scene.scene_interior_exterior_option_id,
			'day_night_option_id': this.scene.scene_day_night_option_id,
			'location_id': '',
			'location_name': undefined,
			'location_set_id': '',
			'location_set_name': undefined,
			'added_scene': this.scene.added_scene,
			'establishing_shoot': this.scene.establishing_shoot,
			'flashback': this.scene.flashback,
			'manually_produced': this.scene.manually_produced,
			'description': this.scene.description ? this.scene.description : '',
			'characters': [],
			'elements': [],
			'events': [],
			'comments': []
		}
		this.formData.location_id = this.scene.location_id
		setTimeout(() => {
			this.formData.location_set_id = this.scene.location_set_id
		}, 300);
		if (this.scene.all_character_ids) {
			this.getCharacters();
		}
		if (this.scene.all_elements_ids) {
			this.getElements();
		}
		if (this.scene.all_events_ids) {
			this.getevents();
		}
		if (this.scene.all_comments_ids) {
			this.getcomments();
		}
		this.loading = false;
	}
	getCharacters() {
		const a = this.scene.all_character_ids.split(',');
		for (let ch of this.viewData.characters) {
			const b = Object.assign([], this.viewData.characters);
			this.filteredCharacters.push(b)
			if (a.indexOf(ch.id.toString()) >= 0) {
				const b: any = {
					'character_role_id': ch.character_role_id ? ch.character_role_id : '',
					'character_id': ch.id,
					'character_name': undefined,
					'quantity': ch.quantity,
				}
				this.formData.characters.push(b)
			}
		}
		if (this.scene.characters_list) {
			if (this.scene.characters_list.length > 0) {
				this.formData.characters.map((ch:any) => {
					let chFind = this.scene.characters_list.find(cha => cha.character_id == ch.character_id);
					ch['wd_change'] = chFind.wd_change;
					ch['wd_comment'] = chFind.wd_comment;
				})
			}
		}
		if (this.scene.characters_list.length > 0) {
			this.formData.characters.map((ch:any) => {
				let chFind = this.scene.characters_list.find(cha => cha.character_id == ch.character_id);
				ch['wd_change'] = chFind.wd_change;
			})
		}
	}
	getevents() {
		const a = this.scene.all_events_ids.split(',')
		const types = this.scene.all_event_type_ids.split(',')
		const names = this.scene.all_event_names.split(',')

		for (let itm of this.viewData.events) {
			if (a.indexOf(itm.id.toString()) >= 0) {
				const b: any = {
					'event_id': itm.id,
					'event_name': undefined,
					'event_type_id': itm.event_type_id ? itm.event_type_id : '',
				}
				this.formData.events.push(b)

			}
	}
}
	getElements() {
		const a = this.scene.all_elements_ids.split(',')
		for (let element of this.viewData.elements) {
			if (a.indexOf(element.id.toString()) >= 0) {
				const b: any = {
					'element_id': element.id,
					'element_category_id': element.element_category_id,
					'element_name': undefined
				}
				this.formData.elements.push(b)
			}
		}
	}

	getcomments() {
		const a = this.scene.all_comments_ids.split(',')
		const c = this.scene.all_comments.split('&/&')
		const d = this.scene.all_comments_users.split(',')
		let pos = 0
		for (let itm of a) {
			const b: any = {
				'comment_id': itm,
				'comment': c[pos],
				'user_id': d[pos]
			}
			pos++
			this.formData.comments.push(b)
		}
	}
	
	close() {
		this.closeView.emit()
	}

	constructor(
		private _pS: ProjetcsService,
		public _gS: GlobalService,
		private _fS: FilterService,
		private route: ActivatedRoute
	) { }

	ngOnChanges(changes: SimpleChanges) {
		if(changes["viewData"] && this.viewData){
			this.filterSets();
			if(this.scene)
			this.setValues();
			this.loading = false;
		}
	}

	ngOnInit() {
		this.route.params.subscribe((params: any) => this.projectId = params.id);
		this.validate_scene_data();
		
		
		
		
	}
	validate_scene_data(){
		if (!this.viewData || Object.keys(this.viewData).length === 0) {
			if (this.loading) this.loading = true;
			this._pS.getScenesData(this.project.id)
					.subscribe(
						data => {
							const rdata: any = data;
							this.viewData = rdata;
							this.validate_scene()
						}
					
				);	
		} else {
			this.validate_scene()
		}
	}
	validate_scene(){
		if (!this.scene || Object.keys(this.scene).length === 0) {
			if (this.loading) this.loading = true;
			console.log("scene_id")
			console.log(this.scene_id)
				this._pS.getSceneDetail(this.scene_id)
				.subscribe(
					(data: any) => {
						const rdata: any = data;
						this.scene = rdata.scene_to_edit;
						this.setDefault()
					}
			);
			this.loading = false;
		} else {
			this.setDefault()
		}
	}


	setDefault() {
		this.filterSets();
		if (this.scene) {
			this.selectedSets = this.viewData.location_sets || []
			this.setValues();
		} else {
			this.loading = false;

		}
	}

	getInvalidControls(form) {
		const invalidControls = [];
		const controls = form.controls;
		
		for (const name in controls) {
			if (controls[name].invalid) {
				invalidControls.push({ name: name, control: controls[name] });
			}
		}
		
		return invalidControls;
	}
	
	getErrorMessages(control) {
		if (!control.errors) return '';
		
		const messages = [];
		for (const error in control.errors) {
			switch (error) {
				case 'required':
					messages.push('Required');
					break;
				case 'pattern':
					messages.push('Pattern mismatch');
					break;
				default:
					messages.push(error);
			}
		}
		
		return messages.join(', ');
	}
}
